<div class="sidebar-container flex flex-column pt-5 pb-5" [ngClass]="{'mobile-mode': isMobileView}">
  
  <!-- Mobile Header (Logo and Close Button) -->
  <div class="mobile-header" *ngIf="isMobileView">
    <img src="assets/images/logo/logo-yellow.svg" alt="GradPilots" style="height: 32px;" onerror="this.src='assets/images/logo.png'" />
    <button class="close-btn" (click)="onCloseClick()">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <!-- All Documents Section -->
  <div class="section-title" [ngClass]="{'mt-0': !isMobileView}">All Documents</div>
  <ul class="filter-list">
    <li class="filter-item cursor-pointer" *ngFor="let item of allDocuments" [ngClass]="{'active': activeFilter === item.label}" (click)="selectFilter(item.label)">
      <span>{{ item.label }}</span>
      <span class="count-badge" *ngIf="item.count !== null">{{ item.count }}</span>
    </li>
  </ul>

  <div class="divider"></div>

  <!-- By Category Section -->
  <div class="section-title">By Category</div>
  <ul class="filter-list">
    <li class="filter-item cursor-pointer" *ngFor="let item of byCategory" [ngClass]="{'active': activeCategoryId === item.category}" (click)="selectCategory(item.category)">
      <span>{{ item.label }}</span>
      <span class="count-badge">{{ getCategoryCount(item.category) }}</span>
    </li>
  </ul>

  <div class="divider"></div>

  <!-- By University Section -->
  <div class="section-title">By University</div>
  <ul class="filter-list university-list">
    <li class="filter-item" *ngFor="let item of byUniversity">
      <!-- <span>{{ item.label }}</span>
      <span class="university-badge" *ngIf="item.count !== null">{{ item.count }}</span> -->
    </li>
  </ul>

</div>
